import { render, staticRenderFns } from "./Events1.vue?vue&type=template&id=3a0fd7c4&scoped=true&"
import script from "./Events1.vue?vue&type=script&lang=js&"
export * from "./Events1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0fd7c4",
  null
  
)

export default component.exports